import "./Stats.css";

const STATS = [
    { value: "3 decades", label: "of Pioneering" },
    { value: "1000+", label: "Missions Delivered" },
    { value: "100%", label: "In-house Engineering" },
    { value: "09", label: "Utility Patents" },
];

export const Stats = () => {
    
    return (
        <section
            data-testid="stats-section"
            className="stats-section py-5 py-md-10"
        >
            <div className="container-db">
                {/* <div className="d-flex align-items-end justify-content-between mb-3 flex-wrap gap-4">
                    <div>
                        <div className="font-mono-tech section-eyebrow mb-3 fade-in-up ">
                            ⟶ Field Report
                        </div>
                        <h2 className="font-heading section-heading mb-0">
                            Built on
                            <br /> Decades of <span className="text-primary-custom">Signal</span>
                        </h2>
                    </div>
                    <p className="stats-desc m-0 fs-6">
                        From India's first patent-pending camera tracking system to mission-critical
                        defence simulators —  we measure work in deployments, not slides.
                    </p>
                </div> */}

                <div className="stats-grid-wrapper mt-2">
                    <div className="row g-0">
                        {STATS.map((s) => (
                            <div
                                key={s.label}
                                data-testid={`stat-${s.label.replace(/\s+/g, "-").toLowerCase()}`}
                                className="col-6 col-md-3 stats-card p-4 p-md-5"
                            >
                                <div className="font-heading stats-value fs-3">
                                    {s.value}
                                </div>
                                <div className="font-mono-tech stats-label mt-3">
                                    {s.label}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Stats;
